// client/src/pages/public/UnauthorizedPage.jsx
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ShieldAlert, LogOut, ArrowLeft, UtensilsCrossed } from 'lucide-react';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const { usuario, cerrarSesion } = useAuth();

  const handleCerrarSesion = async () => {
    await cerrarSesion();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl max-w-md w-full p-8 text-center border border-gray-100">
        <div className="w-20 h-20 bg-red-50 text-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-inner">
          <ShieldAlert className="w-10 h-10" />
        </div>

        <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-xs font-bold rounded-full uppercase tracking-wider mb-3">
          Código 403 • Acceso Denegado
        </span>

        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Acceso No Autorizado
        </h1>

        <p className="text-gray-600 text-sm mb-6 leading-relaxed">
          Tu cuenta no tiene los permisos requeridos para acceder al panel administrativo del POS.
        </p>

        {usuario && (
          <div className="bg-gray-50 rounded-2xl p-4 mb-6 border border-gray-200 text-left text-xs space-y-1">
            <div className="text-gray-500 font-medium">Sesión activa como:</div>
            <div className="font-bold text-gray-800 text-sm">{usuario.nombre || usuario.correo}</div>
            <div className="text-gray-500">
              Rol actual: <span className="font-semibold text-red-700">{usuario.rol || 'Sin rol asignado'}</span>
            </div>
          </div>
        )}

        <div className="space-y-3">
          <button
            onClick={handleCerrarSesion}
            className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-4 rounded-xl shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 text-sm"
          >
            <LogOut className="w-4 h-4" />
            <span>Cerrar Sesión e Iniciar con Otra Cuenta</span>
          </button>

          <button
            onClick={() => navigate('/')}
            className="w-full bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-4 rounded-xl transition-colors flex items-center justify-center gap-2 text-sm"
          >
            <UtensilsCrossed className="w-4 h-4" />
            <span>Volver al Menú Principal</span>
          </button>

          <button
            onClick={() => navigate(-1)}
            className="w-full text-xs text-gray-500 hover:text-gray-700 py-1 flex items-center justify-center gap-1"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            <span>Regresar a la página anterior</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
